export default "__VITE_ASSET__2Y0xn8EX__"